import React, { Component } from 'react';

class ConfirmTickets extends Component {
  constructor(props) {
    super(props);    
    this.state = {...props};
  }
  componentWillReceiveProps() {
    this.setState({
      ...this.props
    })
  }
  render() {
    return (
      <div className="ticket-dialog">
        <p className="t-title">
          确认购买票种
        </p>
        <div className="ticket-content">
          <div className="ticket selected">
            {/* { this.state.photo && <img src={this.state.photo} className="ticket-img"/> } */}
            <div className="text-detail">
              <p className="ticket-name">{this.state.name}</p>
              <p className="ticket-fee">{this.state.fee}</p>
              <p className="ticket-intro">{this.state.intro}</p>
            </div>
          </div>
        </div>
        <div className="button-info">
          <p className="price">总价：<span>￥{this.state.fee}</span></p>
          <div className="button active" onClick={() => {
            this.props.receiveData({
              isSure: true
            })
          }}>
            确认购买
          </div>
          <div className="button grey" onClick={() => {
            this.props.receiveData({
              isSure: false
            })
          }}>
          重新选票
          </div>
        </div>
      </div>
    )
  }
}

export default ConfirmTickets;
